import { setStore, getStore } from "@/util/store";
import { diff } from "@/util/util";
import website from "@/const/website";
const isFirstPage = website.isFirstPage;
const tagWel = website.firstPage;
const tagObj = {
  label: "", // 标题名称
  i18nKey: "", // 国际化标签
  value: "", // 标题的路径
  params: "", // 标题的路径参数
  query: "", // 标题的参数
  group: [] // 分组
};

// 处理首个标签
function setFistTag(list) {
  if (list.length === 1) {
    list[0].close = false;
  } else {
    list.forEach(ele => {
      if (ele.label === tagWel.label && isFirstPage === false) {
        ele.close = false;
      } else {
        ele.close = true;
      }
    });
  }
}
const navs = {
  state: {
    // isOpenTag: false,
    // setNewOpen: {
    //   title: "",
    //   href: ""
    // },
    tagList: getStore({ name: "tagList" }) || [],
    tag: getStore({ name: "tag" }) || tagObj,
    tagWel: tagWel
  },
  actions: {
    // setOpenTag({ commit }, data) {
    //   commit("OPEN_TAG", data);
    // }
  },
  mutations: {
    // OPEN_TAG: (state, data) => {
    //   state.setNewOpen = data;
    //   state.isOpenTag = true;
    // },
    // CLOSE_TAG: (state) => {
    //   // state.openTag = action;
    //   state.isOpenTag = false;
    // },
    ADD_TAG: (state, action) => {
      state.tag = action;
      setStore({ name: "tag", content: state.tag, type: "session" });
      if (state.tagList.some(ele => diff(ele, action))) return;
      state.tagList.push(action);
      setFistTag(state.tagList);
      setStore({ name: "tagList", content: state.tagList, type: "session" });
    },
    SET_TAG: (state, action) => {
      state.tag = action;
      setStore({ name: "tag", content: state.tag, type: "session" });
    },
    UPDATE_TAG: (state, action) => {
      state.tag = action;
      state.tagList = state.tagList.map(item => {
        if (item.label === action.label) {
          item.value = action.value;
        }
        return item;
      });
      setStore({ name: "tagList", content: state.tagList, type: "session" });
      setStore({ name: "tag", content: state.tag, type: "session" });
    },
    DEL_TAG: (state, action) => {
      state.tagList = state.tagList.filter(item => {
        return !diff(item, action);
      });
      setFistTag(state.tagList);
      setStore({ name: "tagList", content: state.tagList, type: "session" });
    },
    DEL_ALL_TAG: state => {
      state.tagList = [state.tagWel];
      setStore({ name: "tagList", content: state.tagList, type: "session" });
    },
    DEL_TAG_OTHER: state => {
      state.tagList = state.tagList.filter(
        item => item.value === state.tag.value || item.value === "/vendor/#/wel"
      );
      setFistTag(state.tagList);
      setStore({ name: "tagList", content: state.tagList, type: "session" });
    }
  }
};
export default navs;
